import React from 'react';

import { Box } from '@lightspeed/flame/Core';

import { createReactRenderer } from '../helpers/react-renderer';

import { HighlightBadge } from '../MultiLocationSaleModal/HoverableCard';

export const NewPillBadge = ({ text }: { text: string }) => {
  return (
    <HighlightBadge style={{ height: '24px', color: '#020203' }} variant="success" text={text} />
  );
};

type DismissibleBadgeProps = {
  text?: string;
  expireIsoDate?: string;
  className?: string;
};

export default function AutoDismissPillBadge({
  text = 'New',
  expireIsoDate,
  className,
}: DismissibleBadgeProps) {
  const [showPillBadge, setShowPillBadge] = React.useState(false);

  React.useEffect(() => {
    if (expireIsoDate) {
      const todayDateLocalTimezone = new Date();
      const expiryDateInLocalTimezone = new Date(`${expireIsoDate}T00:00:01`); // If you don't specify Z, it will use local timezone
      const showBadge = todayDateLocalTimezone < expiryDateInLocalTimezone;
      setShowPillBadge(showBadge);
    } else {
      setShowPillBadge(true);
    }
  }, [expireIsoDate]);

  if (!showPillBadge) {
    return null;
  }

  return (
    <Box
      data-test="auto-dismissible-badge"
      {...(expireIsoDate ? { 'data-expire-iso': expireIsoDate } : undefined)}
      className={className}
      style={{ position: 'absolute', zIndex: 10, top: '-8px', right: '6px' }}
    >
      <NewPillBadge text={text} />
    </Box>
  );
}

const RenderedComponent = createReactRenderer({
  component: AutoDismissPillBadge,
  selector: '[data-react-root="AutoDismissNewBadge"]',
});

history.onChangeState(
  { tab: undefined, form_name: 'ui_tab', id: undefined },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
